import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StartScreen from './StartScreen';
import GameScreen from './GameScreen';
import Marketplace from './MarketPlace';
import LeaderboardPage from './LeaderboardPage';

import './App.css';
import { GameStateProvider } from './GameStateContext';

function App() {
    const [playerName, setPlayerName] = useState('');
    const [scraps, setScraps] = useState(0);
    const [planks, setPlanks] = useState(0);
    const [inventory, setInventory] = useState([]);
    const [equippedAxe, setEquippedAxe] = useState(null);
    const [axeHitPoints, setAxeHitPoints] = useState(30);
    const [isMuted, setIsMuted] = useState(false);
    const [volume, setVolume] = useState(0.5);

    // Load the player name from local storage if it exists
    useEffect(() => {
        const savedName = localStorage.getItem('playerName');
        if (savedName) {
            setPlayerName(savedName);
        }
    }, []);

    const savePlayerName = (name) => {
        setPlayerName(name);
        localStorage.setItem('playerName', name);
    };

    return (
        <GameStateProvider value={{
            playerName, setPlayerName,
            scraps, setScraps,
            planks, setPlanks,
            inventory, setInventory,
            equippedAxe, setEquippedAxe,
            axeHitPoints, setAxeHitPoints,
            isMuted, setIsMuted,
            volume, setVolume
        }}>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<StartScreen savePlayerName={savePlayerName} />} />
                        <Route path="/game" element={<GameScreen />} />
                        <Route path="/marketplace" element={<Marketplace />} />
                        <Route path="/leaderboard" element={<LeaderboardPage />} />
                    </Routes>
                </div>
            </Router>
        </GameStateProvider>
    );
}

export default App;
